import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'absolute top-[106px] right-2 z-30 flex flex-col gap-0.5 shadow-[0px_0px_12px_0px_rgba(0,0,0,0.08)] lg:top-[150px] lg:right-5',
    button:
      'enabled:hover:bg-color-secondary flex size-14 cursor-pointer items-center justify-center bg-white p-2.5 text-black transition'
  }
});
